<template>
  <div class="text-center flex flex-col items-center">
    <img
      :src="profilePic"
      alt="Radovan Hlavatý"
      class="rounded-full w-64 h-64 object-cover mb-4"
    />
    <h1 class="text-xl font-bold uppercase mb-2">Radovan Hlavatý</h1>
    <a
      href="mailto:hello@radohlavaty.com"
      class="group inline-flex items-center gap-2 px-6 py-2 underline hover:no-underline font-semibold rounded-xl transition-all duration-300 hover:shadow-sm hover:bg-gray-100/80 text-gray-900"
    >
      <font-awesome-icon
        icon="fa-regular fa-envelope"
        class="group-hover:animate-wiggle-scale"
      />
      <span>{{ $t("sayHello") }}</span>
    </a>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import profilePic from "@/assets/profile-picture.jpg";

@Options({})
export default class ProfileHeader extends Vue {
  profilePic = profilePic;
}
</script>
